// orange instead of the red danger color: a rollback can be redone, it is not a delete
export const ROLLBACK_COLORS = {
  action: '#c2410c',
  buttonText: '#9a3412',
  buttonBorder: '#e5a372',
  panelBorder: '#f0c8a4',
  panelBackground: '#fff8f1',
};

export const STEP_COLORS = {
  doneCircle: '#a7aebb',
  doneIcon: '#1f2a52',
  upcomingBorder: '#c3c8d2',
  mutedText: '#5a6275',
  connector: '#b8bec9',
};
